// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__12ryj","header":"MergedInvoice_header__3d8To"};